module.exports = __webpack_public_path__ + "img/favonius-warbow.ebd1df51.webp";